import { notFound } from '@tanstack/react-router'

// Release control, not a security boundary: the backend 404s external identities.
interface DealReviewEnvironment {
  VITE_DEAL_REVIEW_ENABLED?: string
}

export function isDealReviewEnabled(environment: DealReviewEnvironment) {
  return environment.VITE_DEAL_REVIEW_ENABLED === 'true'
}

export function requireDealReviewAccess(
  _routeContext: unknown,
  environment: DealReviewEnvironment = import.meta.env
) {
  if (!isDealReviewEnabled(environment)) {
    throw notFound()
  }
}
